<template>
  <a-select
    :allow-clear="true"
    placeholder="请选择"
    option-filter-prop="title"
    :value="value"
    @change="onChangeFn"
  >
    <a-select-option
      v-for="item in options"
      :key="item.valCode"
      :value="item.valCode"
      :title="item.valName"
    >
      {{ item.valName }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref, watch } from "vue";
import { DictValRecord } from "@/views/system/dict/dict.interface";
import { DictService } from "@/views/system/dict/dict.service";
/**
 * 全局组件: 字段选择器
 *
 * 使用方式:
 * <dict-select v-model="formRef.dictCode" code="sex"></dict-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "DictSelectLostOrder",
  props: {
    code: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const options = ref<DictValRecord[]>([]);
    const onChangeFn = (code) => {
      emit("update:value", code);
    };

    onMounted(async () => {
      if (!props.code) {
        return;
      }
      options.value = await DictService.fetchOptionsByDictCode(props.code);
    });
    return {
      options,
      onChangeFn,
    };
  },
});
</script>
